var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lock-closed"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG",
    opacity: 0.4,
    d: "M16.9999 10.7539H6.9936C5.75282 10.7539 4.74219 11.7645 4.74219 13.0152V18.0079C4.74219 19.2486 5.75282 20.2592 6.9936 20.2592H16.9999C18.2406 20.2592 19.2513 19.2486 19.2513 18.0079V13.0152C19.2513 11.7645 18.2406 10.7539 16.9999 10.7539ZM12.7472 17.0074C12.7472 17.4276 12.417 17.7578 11.9967 17.7578C11.5865 17.7578 11.2463 17.4276 11.2463 17.0074V13.0052C11.2463 12.5949 11.5865 12.2547 11.9967 12.2547C12.417 12.2547 12.7472 12.5949 12.7472 13.0052V17.0074Z",
    fill: "#D58B0E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.995 17.0078V13.0056M7.99249 9.97387V7.17232C7.99249 4.86104 9.78361 3 11.995 3C14.2064 3 15.9975 4.86104 15.9975 7.17232V9.97387M16.9981 10.0039H7.00188C5.34084 10.0039 4 11.3446 4 13.0056V17.9983C4 19.6593 5.34084 21 7.00188 21H16.9981C18.6592 21 20 19.6593 20 17.9983V13.0056C20 11.3546 18.6592 10.0039 16.9981 10.0039Z",
    stroke: "#D58B0E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.1b37608e42a1bc66a32f6329ff5ee44e.svg";
export { ForwardRef as ReactComponent };